import styles from "./sidebar.module.css";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function Sidebar({ setIsLoggedIn }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const menuItem = [
    {
      path: "/dashboard",
      name: "Dashboard",
    },
    {
      path: "/analytics",
      name: "Analytics",
    },
    {
      path: "/create-edit-quiz",
      name: "Create Quiz",
    },
  ];

  function handleLogout() {
    localStorage.removeItem("jwToken");
    localStorage.removeItem("userId");
    setIsLoggedIn(false);
    navigate("/");
  }
  return (
    <>
      <aside className={styles.sidebar_container}>
        <div className={styles.brandRow}><h2 className={styles.quiz_title}><span>Q</span>Quizzie</h2><button className={styles.menuButton} aria-label="Toggle navigation" aria-expanded={menuOpen} onClick={() => setMenuOpen(!menuOpen)}>☰</button></div>
        <nav className={`${styles.sideMenu_wrapper} ${menuOpen ? styles.menuOpen : ""}`} aria-label="Main navigation">
          {menuItem.map((item, index) => (
            <NavLink
              to={item.path}
              key={index}
              className={({ isActive }) => isActive ? styles.activeLink : ""}
              onClick={() => setMenuOpen(false)}
            >
              <div className={styles.link_text}>{item.name}</div>
            </NavLink>
          ))}
        </nav>
        <button className={styles.logoutBtn} onClick={handleLogout}>Log out</button>
      </aside>
    </>
  );
}
